
import { observer } from 'mobx-react-lite';
import { useParams, Link } from 'react-router-dom';

import Stack from '@mui/joy/Stack';
import Tooltip from '@mui/joy/Tooltip';
import Typography from '@mui/joy/Typography';

import useChatRoom from 'hooks/useChatRoom';

import FancyIcon from 'components/FancyIcon';

import { PROJECT_HEADER_FONT_SIZE } from "components/ListicleProject";

const ChatTopper = observer(() => {

    const { uuid } = useParams<{uuid: string}>();
    const { getChatRoom } = useChatRoom();

    // we load it in ChatRoomContainer
    const room = uuid ? getChatRoom(uuid) : null;



    return (
        <Stack
            direction="row"
            width="100%"
            spacing={1.5} alignItems="center">
            <Link to={"/chat"}>
                <Tooltip arrow title={"Back to chat home"}>

                    <Typography
                        startDecorator={<FancyIcon name="DayOnesChat" />}
                        fontSize={PROJECT_HEADER_FONT_SIZE}
                        level="title-lg">
                        {room?.name || 'Chat'}
                    </Typography>

                </Tooltip>
            </Link>


        </Stack>


    );
});

export default ChatTopper;
